import styled from 'styled-components';

export const GridContainer = styled.section`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 24px;

  height: 80vh;
  align-items: center;

  @media (max-width: 900px) {
    grid-template-columns: 1fr;
  }
`;

export const Grid = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  @media (max-width: 900px) {
    img {
      width: 13rem;
    }
  }
`;

export const RightGrid = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;

  > h1 {
    font-size: 112px;
    font-weight: bold;
    color: ${props => props.theme.primaryColor};
    margin: 0 0;
    margin-bottom: 16px;
    pointer-events: none;
    user-select: none;
  }

  > h2 {
    font-weight: bold;
    font-size: 36px;
    color: ${props => props.theme.textColor};
    margin-bottom: 32px;
    pointer-events: none;
    user-select: none;
  }

  > p {
    font-size: 18px;
    line-height: 28px;
    color: ${props => props.theme.textColor};
    opacity: 0.8;
    margin-bottom: 32px;
    pointer-events: none;
    user-select: none;
  }

  > div {
    width: 100%;
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }

  button {
    margin-left: 0rem !important;
  }

  @media (max-width: 900px) {
    justify-content: center;
    align-items: center;

    > p {
      text-align: center;
    }

    button {
      margin-left: 0rem !important;
    }

    > div {
      justify-content: space-between;
    }
  }
`;
